var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-1",
        },
        [
          _c("div", { staticClass: "col-7" }, [
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v(_vm._s(_vm.offerType) + " " + _vm._s(_vm.offerName)),
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "pt-xl-1 py-0 mb-0 fw-bold",
                attrs: { "aria-hidden": "true" },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.offerType) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "h2",
              { staticClass: "h1 py-0 mb-0", attrs: { "aria-hidden": "true" } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.offerName) +
                    "\n            "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.priceDetails.basePrice
            ? _c(
                "div",
                { staticClass: "ps-1 text-end" },
                [
                  _c("Price", {
                    attrs: {
                      price: _vm.priceDetails.basePrice,
                      "show-by-month": true,
                      "is-cents-format": false,
                      "is-compact": true,
                      custom: "text-dark text-decoration-line-through",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.priceDetails.discounts, function (discount, index) {
        return _c(
          "div",
          {
            key: `${_vm.modalId}-discount-${index}`,
            staticClass: "ob1-inline-promise ob1-inline-promise-warning mb-1",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center w-100",
              },
              [
                _c("div", { staticClass: "col-7 lead" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(discount.label) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-end ps-1" },
                  [
                    _c("Price", {
                      attrs: {
                        price: discount.amount,
                        "show-by-month": true,
                        "is-cents-format": false,
                        "is-mini": true,
                        "price-details": discount.durationLabel || "",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        )
      }),
      _vm._v(" "),
      _vm.priceDetails.cashbacks && _vm.priceDetails.cashbacks.length > 0
        ? _c(
            "div",
            { staticClass: "mb-1" },
            [
              _vm.priceDetails.discounts &&
              _vm.priceDetails.discounts.length > 0
                ? _c("hr", {
                    staticClass: "dotted-separator my-1",
                    attrs: { "aria-hidden": "true" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.priceDetails.discounts &&
              _vm.priceDetails.discounts.length > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center pb-2",
                    },
                    [
                      _c("span", { staticClass: "lead fw-bold" }, [
                        _vm._v(_vm._s(_vm.priceDetails.totalBeforeRefundLabel)),
                      ]),
                      _vm._v(" "),
                      _c("Price", {
                        attrs: {
                          price: _vm.priceDetails.totalBeforeRefund,
                          "show-by-month": true,
                          "is-cents-format": false,
                          "is-compact": true,
                          custom: "text-dark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.priceDetails.cashbacks, function (cashback, index) {
                return _c(
                  "div",
                  {
                    key: `${_vm.modalId}-cashback-${index}`,
                    staticClass:
                      "ob1-inline-promise ob1-inline-promise-warning mb-1",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center w-100",
                      },
                      [
                        _c("div", { staticClass: "col-7" }, [
                          _c("p", {
                            directives: [
                              {
                                name: "msh-html",
                                rawName: "v-msh-html",
                                value: cashback.label,
                                expression: "cashback.label",
                              },
                            ],
                            staticClass: "lead mb-0",
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "ob1-link underline-link",
                              attrs: {
                                href: cashback.url,
                                target: "_blank",
                                "aria-label":
                                  cashback.ctaLabel + " (nouvelle fenêtre)",
                              },
                            },
                            [_vm._v(_vm._s(cashback.ctaLabel))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-end ps-1" },
                          [
                            _c("Price", {
                              attrs: {
                                price: cashback.amount,
                                "show-by-month": true,
                                "is-cents-format": false,
                                "is-mini": true,
                                "price-details":
                                  cashback.durationLabel +
                                  "<br>" +
                                  cashback.invoiceMention,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("hr", {
          staticClass: "separator separator--gray4 my-1",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-start" },
          [
            _c("p", {
              directives: [
                {
                  name: "msh-html",
                  rawName: "v-msh-html",
                  value: _vm.priceDetails.finalPriceLabel,
                  expression: "priceDetails.finalPriceLabel",
                },
              ],
              staticClass: "lead fw-bold mb-0",
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-end" },
              [
                _c("Price", {
                  attrs: {
                    price: _vm.priceDetails.finalPrice,
                    "initial-price": _vm.tileFinalPricePermanent,
                    "price-details": _vm.offerPrice.priceDetails || "",
                    duration: _vm.tileDuration,
                    "is-cents-format": false,
                    "show-from": _vm.offerPrice.showFrom,
                    "show-by-month": _vm.offerPrice.showByMonth,
                    "show-promo-duration": _vm.offerPrice.showPromoDuration,
                    "show-end-of-promotion-price":
                      _vm.offerPrice.showEndOfPromotionPrice,
                    "show-children-promotion-price":
                      _vm.offerPrice.showChildrenPromotionPrice,
                    "cashback-type": _vm.cashbackType,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }